class ListCharactersResponse {
	constructor(characterData) {
		this.characters = characterData;
	}

	formatCharacterData() {
		if (Array.isArray(this.characters)) {
			return this.characters.map((character) => ({
				id: character.id,
				name: character.name,
				imageUrl: character.input_image,
				characterType: character.character_type,
				features: character?.features
					? {
							age: character?.features?.age,
							bodyType: character?.features?.body_type,
							gender: character?.features?.gender,
						}
					: null,
				prompt: character.prompt,
				isDefault: character.is_default,
			}));
		}
		return {
			id: this.characters.id,
			name: this.characters.name,
			imageUrl: this.characters.input_image,
			characterType: this.characters.character_type,
			features: this.characters?.features
				? {
						age: this.characters?.features?.age,
						bodyType: this.characters?.features?.body_type,
						gender: this.characters?.features?.gender,
					}
				: null,
			prompt: this.characters.prompt,
			isDefault: this.characters.is_default,
		};
	}
}

export default ListCharactersResponse;
